import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistorySection from 'Components/HistorySection';
import { formatTime } from 'neuro-utils';
import { getPatientAgeInMonthsWithOneDecimal } from 'Utility/patientInfo';
import { showPatientAgeInMonthsOnForm } from '../../utils';
import InfoPopover from 'Components/InfoPopover';
import HistoryRowListing from 'Components/HistoryRowListing';
import { Item } from 'Components/Grid';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { formatPartialDate } from 'Utility/date';
import { chop_intend } from 'neuro-schemas';

const { calculateScore } = chop_intend;

const CHOPINTEND = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'motor.chopINTEND'} />}
      newButton={
        <DocumentCreationButton
          name="chop_intend"
          text={'motor.newChopINTEND'}
          onClick={startEdit({}, 'chop_intend')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id={'general.date'} />
            </Item>
            <Item xs={2}>
              <FormattedMessage id="general.timeOfDay" />
            </Item>
            <Item xs={2}>
              <FormattedMessage id="motor.hoursSinceLastFeedingShort" />
            </Item>
            <Item xs={2}>
              <FormattedMessage id={'motor.chopINTENDScore'} />
            </Item>
          </>
        }
        contentFormat={d => {
          const score = calculateScore(d);
          return (
            <>
              <Item xs={2} id={'ciDate'}>
                {showPatientAgeInMonthsOnForm(d.date) ? (
                  <FormattedMessage
                    id="motor.dateAndMonth"
                    values={{
                      date: formatPartialDate(d.date),
                      months: getPatientAgeInMonthsWithOneDecimal(d.date),
                    }}
                  />
                ) : (
                  formatPartialDate(d.date)
                )}
              </Item>
              <Item xs={2}>{d.time ? formatTime(d.time) : '-'}</Item>
              <Item xs={2}>{d.hoursSinceLastFeeding ?? '-'}</Item>
              <Item xs={2} id={'ciScore'}>
                {score ?? <InfoPopover text="general.notFilled" color="primary" />}
              </Item>
            </>
          );
        }}
        makeControls
        historyRowControls={d => (
          <div id={'ciHistoryControl'}>
            <HistoryRowControls document={d} startEdit={startEdit} view={view} />
          </div>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'chop_intend'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default CHOPINTEND;
